import { render } from "./SVGArrow.vue?vue&type=template&id=5415df04&scoped=true&ts=true"
import script from "./SVGArrow.vue?vue&type=script&lang=ts"
export * from "./SVGArrow.vue?vue&type=script&lang=ts"

import "./SVGArrow.vue?vue&type=style&index=0&id=5415df04&lang=scss&scoped=true"

import exportComponent from "/home/runner/_work/SDD-gotime-web-client/SDD-gotime-web-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5415df04"]])

export default __exports__